import * as React from "react"
import * as ReactModal from "react-modal"
import {Style as ModalStyle} from "react-modal-types"
import {CSSWideKeyword} from "react";

export interface Props extends React.Props<{}> {
	isOpen: boolean
	title: string
	onRequestClose: () => void
	style?: React.CSSProperties
}

export class Modal extends React.Component<Props, {}> {
	render() {
		ReactModal.setAppElement(document.body)

		const style:ModalStyle = {
			content: {
				border:     "none",
				background: "none",
			}
		}

		return <div>
			<ReactModal contentLabel={this.props.title} style={style} isOpen={this.props.isOpen} onRequestClose={() => this.props.onRequestClose()}>
				<div
					className="ui-dialog ui-widget ui-widget-content ui-corner-all ui-front"
					style={this.props.style}
				>
					<div className="ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix">
						<span className="ui-dialog-title">{this.props.title}</span>
						<button
							type="button"
							className="ui-button ui-widget ui-state-default ui-corner-all ui-button-icon-only ui-dialog-titlebar-close"
							onClick={() => this.props.onRequestClose()}
						>
							<span className="ui-button-icon-primary ui-icon ui-icon-closethick" />
						</button>
					</div>
					<div className="ui-dialog-content ui-widget-content">
						{this.props.children}
					</div>
				</div>
			</ReactModal>
		</div>
	}
}

export const centeredModalProps = (minWidth?: CSSWideKeyword | any): React.CSSProperties => {
	const style: React.CSSProperties = {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		maxWidth: '1000px',
		maxHeight: '500px',
		overflow: "scroll"
	}

	return {...style, ...(minWidth !== undefined ? {minWidth: minWidth} : {})}
}



// WEBPACK FOOTER //
// ./src/lib/sbhtml/modal.tsx